module.exports = __webpack_public_path__ + "static/healtcare-blog-img-1-c1cf3173df461025a329ed7f8b952642.jpg";